import { makeStyles } from '@material-ui/styles';

export const useSelectInputStyle = makeStyles(theme => ({
  fakeFormControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));
